import axios from 'axios';
import { MDBBtn, MDBContainer, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import Reviews from './../products/reviews/Reviews';
import { MiscContext } from '../context/MiscProvider';

const TestimonialsModal = ({ testimonialModal, toggleTestimonialModal, setTestimonialModal}) => {

  
  const { testimonials, setTestimonials } = useContext(MiscContext);
  
  
  return (
    <MDBContainer>
    <MDBModal className='modal-backdrop.show' open={testimonialModal} onClose={() => setTestimonialModal(false)}>

    
        <MDBModalDialog centered={true}  style={{ color: '#ac2bac' }} size="lg">
        <MDBModalContent>   
        <MDBModalHeader>
             
              <MDBBtn className='btn-close' color='none' onClick={() => setTestimonialModal(false)}></MDBBtn>
            </MDBModalHeader>      
          <MDBModalBody>            
           
            <Reviews reviews={testimonials} setReviews={setTestimonials}/> 
          </MDBModalBody>
          <MDBModalFooter>   <MDBBtn size='sm'  className='text-black'   
          color="link"
          onClick={() => setTestimonialModal(false)}
        >
          Close
        </MDBBtn> </MDBModalFooter>
          </MDBModalContent>
         
        </MDBModalDialog>
       
      </MDBModal>
    </MDBContainer>
  );
}
TestimonialsModal.propTypes = {
  item: PropTypes.shape({
    thumbnails: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string,
    subdomain: PropTypes.string,
    domainIds: PropTypes.arrayOf(PropTypes.string),
    domainIdToName: PropTypes.objectOf(PropTypes.string),
    id:PropTypes.string,
  }),
  testimonialModal: PropTypes.bool,
  setTestimonialModal:PropTypes.func,
  toggleTestimonialModal:PropTypes.func,
};



export default TestimonialsModal;
